import { render, staticRenderFns } from "./TableRevisions.vue?vue&type=template&id=796df235&scoped=true"
import script from "./TableRevisions.vue?vue&type=script&lang=js"
export * from "./TableRevisions.vue?vue&type=script&lang=js"
import style0 from "./TableRevisions.vue?vue&type=style&index=0&id=796df235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796df235",
  null
  
)

export default component.exports